<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>存取记录列表</b></p>

            <!-- <el-select v-model="equipmentId" placeholder="请选择" style="width:220px" @change="monthChange">
                <el-option v-for="item in equipmentList" :key="item.value" :label="item.equipmentName" :value="item.id">
                </el-option>
            </el-select> -->

            <el-date-picker v-model="timeFrameValue" type="datetimerange" :picker-options="pickerOptions"
                @change="monthChange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
            </el-date-picker>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button round type="success" @click="deposit">存</el-button>
                <span>-</span>
                <el-button round type="primary" @click="takeOut">取</el-button>
            </p>

        </div>

        <el-table :data="logList" style="width: 100%" highlight-current-row>
            <el-table-column prop="maker" label="操作人" min-width="10%">
            </el-table-column>

            <el-table-column prop="createdTime" label="操作时间" min-width="15%">
            </el-table-column>

            <el-table-column prop="cabinetName" label="柜号" min-width="15%">
            </el-table-column>

            <el-table-column prop="accessType" label="存取类型" min-width="10%">
            </el-table-column>

            <el-table-column prop="quantity" label="数量" min-width="10%">
            </el-table-column>

            <el-table-column prop="stuff" label="东西" min-width="25%">
            </el-table-column>

            <el-table-column prop="equipmentName" label="设备" min-width="15%">
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="10" :page-count="pageCount" layout="total, prev, pager, next"
                :total="total" @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div>

        <el-dialog title="存取详情" :visible.sync="dlgFormVisible" width="40%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">


                <el-form-item label="刀具" required :label-width="formLabelWidth" prop="cutterName">

                    <el-select v-model="form.cutterName" filterable remote reserve-keyword placeholder="请输入关键字"
                        :remote-method="searchCustomer" :loading="loading" @change="cutChange" style="width:220px">
                        <el-option v-for="item in cutterList" :key="item.value" :label="item.cutterName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="现有数量" :label-width="formLabelWidth">
                    <el-input v-model="form.totalQty" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item :label="accessStr" required :label-width="formLabelWidth" prop="quantity">
                    <el-input-number v-model="form.quantity" :step="1" :min="1" style="width:220px"></el-input-number>
                </el-form-item>

                <el-form-item label="设备" required :label-width="formLabelWidth" prop="equipmentName">

                    <el-select v-model="form.equipmentName" placeholder="请选择设备" style="width:220px"
                        @change="equipChange">
                        <el-option v-for="item in equipmentList" :key="item.value" :label="item.equipmentName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <div style="width:350px;display: inline-block;"></div>

                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => addAccessLog('ruleForm')">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "AccessLog",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            logList: [],

            equipmentId: '',

            timeFrameValue: '',
            startTime: null,
            endTime: null,

            pageIndex: 0,
            total: 0,
            pageCount: 0,

            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            rules: {
                cutterName: [
                    { required: true, message: '请选择刀具', trigger: 'blur' },
                    { required: true, message: '请选择刀具', trigger: 'change' }
                ],
                quantity: [
                    { required: true, message: '请输入数量', trigger: 'blur' },
                    { required: true, message: '请输入数量', trigger: 'change' }
                ],
                equipmentName: [
                    { required: true, message: '请选择设备', trigger: 'blur' },
                    { required: true, message: '请选择设备', trigger: 'change' }
                ]
            },

            dlgFormVisible: false,
            cutterList: [],
            form: {
                cutterId: '',
                cutterName: '',

                totalQty: 0,

                // cabinetId:'',
                accessType: 0,
                quantity: 1,
                equipmentName: '',

                remark: ''
            },
            accessStr:'存入',
            equipmentList: []
        }
    },
    methods: {
        getEquipAll() {
            this.$axios({
                method: "post",
                url: "/shiro/equipment/getAll",
                data: {
                    id: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.equipmentList = data.data

            })
        },
        equipChange(value) {

            this.equipmentId = value
        },
        deposit() {
            this.form.accessType = 1
            this.accessStr='存入'

            this.openDialog()
        },
        takeOut() {
            this.form.accessType = 0
            this.accessStr='取出'

            this.openDialog()
        },
        openDialog() {
            this.getCutterAll()

            this.form.cutterName = ''
            this.form.totalQty=0
            this.form.quantity = 1
            this.form.remark = ''

            this.form.equipmentName = ''

            this.dlgFormVisible = true
        },
        cutChange(value) {
            // console.log(value)
            this.form.cutterId = value

            let cutter = this.cutterList.filter(item => item.id == value)
            // console.log('cut')
            // console.log(cutter)

            this.form.totalQty = cutter[0].quantity
        },
        addAccessLog(formName) {

            if (this.form.accessType == 0 && this.form.totalQty < this.form.quantity) {
                this.$message({
                    type: 'info',
                    message: '数量超出上限'
                })
                return
            }

            this.$refs[formName].validate((valid) => {
                if (valid) {

                    this.$axios({
                        method: "post",
                        url: "/shiro/access/log/add",
                        data: {
                            maker: this.userId,
                            // cabinetId:'',
                            accessType: this.form.accessType,
                            stuffId: this.form.cutterId,
                            quantity: this.form.quantity,
                            equipmentId: this.equipmentId,
                            remark: this.form.remark,
                            companyId: this.companyId
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message({
                                type: 'info',
                                message: data.msg
                            })
                            return
                        }

                        this.getAll()
                        this.dlgFormVisible = false

                    })
                }
            })


        },
        monthChange() {
            this.startTime = this.timeFrameValue[0]
            this.endTime = this.timeFrameValue[1]

            this.getAll()
        },
        searchByStatus(val) {

            this.getAll(val)
        },
        getCutterAll() {
            this.$axios({
                method: "post",
                url: "/shiro/base/cutter/getAll",
                data: {
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.cutterList = data.data

            })
        },
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/access/log/getAll",
                data: {
                    companyId: this.companyId,
                    pageIndex: this.pageIndex,
                    pageNum: 10,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    // equipmentId: this.equipmentId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                this.logList = data.data
                this.total = this.logList[0].total
                this.pageCount = this.total % 10 == 0 ? this.total % 10 : this.total % 10 + 1

                for (let i in this.logList) {
                    this.logList[i].createdTime = this.$moment(this.logList[i].createdTime).format("YYYY-MM-DD HH:mm:ss")

                    if (this.logList[i].accessType == 0) {
                        this.logList[i].accessType = '取'
                    } else if (this.logList[i].accessType == 1) {
                        this.logList[i].accessType = '存'
                    }
                }
            })
        },
        pageClick(currentPage) {

            this.pageIndex = (currentPage - 1) * 10
            this.getAll()
        }
    },
    mounted() {
        this.getAll()


        this.getEquipAll()
    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>